import React from 'react'
import {observer} from 'mobx-react'
import {Stack, Text} from '../../../vanilla'
import {Link} from 'react-router-dom'
import { useOrderStore } from '../../../store/hooks/useStore'

interface CheckoutErrorMessageProps {
  isTopUpPage: boolean
}

export const CheckoutErrorMessage = observer(({isTopUpPage}: CheckoutErrorMessageProps) => {
  const {paymentErrorMessage} = useOrderStore()

  const CustomerCareLink = () => (
    <>
      {' '}
      If this is not the first time you have seen this message, please{' '}
      <Text
        variant="text4"
        lineHeight="shorter"
        color="accent0"
        as={Link}
        to="/customer-support/contact-us"
        textDecoration="underline"
      >
        contact our Customer Care team
      </Text>{' '}
      for assistance.
    </>
  )

  return paymentErrorMessage ? (
    <Stack paddingX={['16px', '20px']} paddingY={['20px', '24px']} style={{background: '#F9E5E9'}}>
      {paymentErrorMessage.showErrorHeading && (
        <Text variant="heading1" lineHeight="shorter" color="accent0">
          Unable to {isTopUpPage ? 'top up your Bonus Card' : 'place order'}
        </Text>
      )}
      <Text variant="text4" lineHeight="shorter" color="accent0">
        {paymentErrorMessage.message}
        {paymentErrorMessage.customLink && 
          <Link to={{pathname: `${paymentErrorMessage.customLink.pathname ?? '/'}`, state: {redirectTo: `${paymentErrorMessage.customLink.redirectTo ?? '/'}`}}}>
            <Text
              as="span"
              variant="text4"
              lineHeight="shorter"
              color="accent0"
              textDecoration="underline"
            >
              {paymentErrorMessage.customLink.text ?? ''}
            </Text>
          </Link>
        }
        {paymentErrorMessage.includeCustomerCare && <CustomerCareLink />}
      </Text>
    </Stack>
  ) : <></>
})
